import React from 'react';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, IconButton, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import DataExtractionIcon from '@mui/icons-material/GetApp';
import WorkIcon from '@mui/icons-material/Work';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';
import AssignmentIcon from '@mui/icons-material/Assignment';

const Sidebar = ({ open, toggleDrawer }) => {
  const navigate = useNavigate();

  const menuItems = [
    {
      text: 'Dashboard',
      icon: <DashboardIcon color="secondary" />,
      path: '/dashboard',
      roles: ['Admin', 'User']
    },
    {
      text: 'Extracción de datos',
      icon: <DataExtractionIcon color="secondary" />,
      path: '/data-extraction',
      roles: ['Admin', 'User']
    },
    {
      text: 'Batch Jobs',
      icon: <WorkIcon color="secondary" />,
      path: '/batch-jobs',
      roles: ['Admin', 'User']
    },
    {
      text: 'Configuración',
      icon: <SettingsIcon color="secondary" />,
      path: '/configuracion',
      roles: ['Admin', 'User']
    },
    {
      text: 'Revisión Manual',
      icon: <AssignmentIcon color="secondary" />,
      path: '/manual-name-review',
      roles: ['Admin', 'User']
    },
    {
      text: 'Estado de Servicios',
      icon: <HealthAndSafetyIcon color="secondary" />,
      path: '/system-health',
      roles: ['Admin', 'User']
    }
  ];

  return (
    <Drawer
      className="drawer"
      variant="persistent"
      anchor="left"
      open={open}
      classes={{ paper: 'drawerPaper' }}
    >
      <div className="drawerHeader">
        <IconButton onClick={toggleDrawer} color="secondary">
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <Divider />
      <List>
        {menuItems.map((item, index) => (
          <ListItem button className="listItem" key={index} onClick={() => navigate(item.path)}>
            <ListItemIcon>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

const SidebarToggle = ({ toggleDrawer }) => {
  return (
    <IconButton onClick={toggleDrawer}>
      <MenuIcon style={{ color: 'white' }} />
    </IconButton>
  );
};

export { Sidebar, SidebarToggle };